module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/bottom-img-8766d95180028d45181c280a240c4d5e.png";